if (process.env.VUE_APP_ENV === 'production') {
  const noisypatterns = [
    'selectedFuturePaymentInstrument',
    'obtaining fingerprint data',
    'sending fingerprint data',
    'fingerprintNotificationPath',
    'triggering form submission',
    'DOMContentLoaded handler took',
  ];
  const origLog = console.log;
  console.log = function (...args) {
    if (args.some(a => typeof a === 'string' && noisypatterns.some(p => a.includes(p)))) return;
    return origLog.apply(this, args);
  };
}

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

import Toaster from '@meforma/vue-toaster';

createApp(App).use(store).use(router).use(i18n).use(Toaster).mount('#app');
